export default "__VITE_ASSET__DSh$gQUl__"